import { useEffect, useState } from "react";

import axios from "axios";

import { PartnerConfig } from "../../types/strapi/PartnerConfig";

import { getStrapiMediaUrl } from "../../helpers/getStrapiMediaUrl";

export function usePartnerConfig(partnerId: string | null) {
  const [partnerConfig, setPartnerConfig] = useState<PartnerConfig | null>(
    null
  );

  const populateParams = [
    "populate[agreements]=true",
    "populate[consents]=true",
    "populate[logoImg]=true",
    "populate[loadingImg]=true",
    "populate[partnerPageConfigs][populate]=PageConfig",
    // "populate[partnerPageConfigs][populate][PageConfig][fields][0]=pageKey" // fetch only pageKey
  ].join("&");

  // Construct endpoint only if partnerId is truthy
  const endpoint = partnerId
    ? `${process.env.REACT_APP_STRAPI_BASE_URL}/api/partners?filters[partnerId][$eq]=${partnerId}&${populateParams}`
    : "";

  useEffect(() => {
    // If no partnerId, reset config and skip fetch
    if (!partnerId) {
      setPartnerConfig(null);
      return;
    }

    async function fetchPartnerConfig() {
      try {
        const res = await axios.get(endpoint, {
          headers: {
            Authorization: `bearer ${process.env.REACT_APP_API_KEY_CMS}`,
          },
        });

        const data = res.data?.data[0];

        if (!data) {
          console.warn("Missing partner config attributes:", data);
          setPartnerConfig(null);
          return;
        }

        const sortedPartnerPageConfigs = (data.partnerPageConfigs || [])
          .slice()
          .sort(
            (a: { order: any }, b: { order: any }) =>
              (a.order ?? 0) - (b.order ?? 0)
          );

        setPartnerConfig({
          partnerId: partnerId as string,
          logoImg: getStrapiMediaUrl(data.logoImg?.url),
          loadingImg: getStrapiMediaUrl(data.loadingImg?.url),
          deepLinkUrl: data.deepLinkUrl,
          returnUrl: data.returnUrl,
          redirectUrl: data.redirectUrl,
          enabledPages: data.enabledPages || [],
          agreements: data.agreements,
          partnerPageConfigs: sortedPartnerPageConfigs,
        });
      } catch (err) {
        console.error("Failed to fetch partner config:", err);
        setPartnerConfig(null);
      }
    }

    fetchPartnerConfig();
  }, [partnerId, endpoint]);

  return partnerConfig;
}
